"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./ResizeGroup"), exports);
tslib_1.__exportStar(require("./ResizeGroup.base"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ResizeGroup/index.js
// module id = 870
// module chunks = 0